export default {
  items: [
    {
      title: true,
      name: '수단지'
    },
    {
      name: '남자수단 검색',
      url: '/manapps/search',
      icon: 'icon-user'
    },
    {
      name: '여서수단 검색',
      url: '/daughterapps/search',
      icon: 'icon-user'
    }
  ]
};
